import { ReactSVG } from "react-svg";
import isNull from "lodash/isNull";
import poppetjeCollection from "../../../../../assets/images/unsupported-language/unsupported-language-popetje.svg";
import nextArrow from "../../../../../assets/images/unsupported-language/locale-error-arrow.svg";
import { ConditionalRender, InteractivePortalLogo } from "../../../../common";
import fullSizeCloud from "../../../../../assets/images/common/extra-big-cloud.svg";

const DesktopUnsupportedLocale = ({ handleContinueInEnglish, language }) => {
    return (
        <div className="h-screen w-screen flex items-center justify-center bg-white overflow-hidden relative">
            <ReactSVG src={fullSizeCloud} className="opacity-50 absolute -left-[75rem] -top-[12rem] z-[1]" />
            <ReactSVG src={fullSizeCloud} className="opacity-50 absolute -right-[75rem] -top-[15rem] z-[1]" />
            <InteractivePortalLogo
                isDesktop
                className="cursor-pointer absolute top-16 left-[9rem] z-30"
                isLogoClickDisabled={false}
            />
            <div className="text-center z-[10]">
                <h1
                    className="text-center font-bold text-[10vh] leading-[10vh] text-[#4598B1] font-[Altivo]"
                >
                    Unsupported <br /> language
                </h1>
                <div className="flex justify-center h-[272px]">
                    <div className="-mt-[43px] -mr-[110px]">
                        <ReactSVG src={poppetjeCollection} />
                    </div>
                </div>
                <div className="flex flex-col justify-center items-center gap-8 mt-8 ">
                    <div className="text-center text-[#4598B1] font-bold text-[20px] leading-[20px] 2xl:text-[25px] 2xl:leading-[25px] tracking-[0.2px]">
                        {isNull(language) ? "Unfortunately we don't speak that yet" : `Unfortunately we don't speak ${language} yet`}
                    </div>
                    <ConditionalRender condition={!isNull(language)}>
                        <div className="text-center text-[#95AFCB] font-normal text-[16px] leading-[20px] 2xl:text-[18px] 2xl:leading-[25px] tracking-[0.16px]">
                            We're working on it.
                        </div>
                    </ConditionalRender>
                    {/* Hiding this temporarily */}
                    {/* <button onClick={handleContinueInEnglish} className='py-[17px] w-[316.5px] flex justify-center items-center gap-3 bg-light-purple text-white rounded-[25px] hover:opacity-95 active:opacity-80'>
                        <ReactSVG src={nextArrow} />
                        <span className="font-medium text-[13px] leading-normal tracking-[3.9px] uppercase">
                            CONTINUE IN ENGLISH
                        </span>
                    </button> */}
                </div>
            </div>
        </div>
    )
}

export default DesktopUnsupportedLocale;